






import Vue from 'vue'

// lets use composition api here to defineComponent
export default Vue.extend({
  name: 'GitHubInfo',
  data() {
    return {
      route: 'https://github.com/elleryba'
    }
  }
})
